<template>
  <q-page class="flex column">
    <PowerBIReport
      :reportId="$router.currentRoute.meta.reportId"
      :autoAuth="$router.currentRoute.meta.autoAuth"
      :ctid="$router.currentRoute.meta.ctid"
      :config="$router.currentRoute.meta.config"
      :filterPaneEnabled="$router.currentRoute.meta.filterPaneEnabled"
      :navContentPaneEnabled="$router.currentRoute.meta.navContentPaneEnabled"
    />
  </q-page>
</template>

<script>
import PowerBIReport from "@/components/PowerBIReport.vue";
export default {
  name: "GenericPowerBIReport",
  components: {
    PowerBIReport,
  },
};
</script>
